var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryDeleteWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5003 20.1243C17.1136 20.1243 16.7426 19.9707 16.4691 19.6972C16.1956 19.4237 16.042 19.0528 16.042 18.666V11.3743C16.042 10.9876 16.1956 10.6166 16.4691 10.3432C16.7426 10.0697 17.1136 9.91602 17.5003 9.91602C17.8871 9.91602 18.258 10.0697 18.5315 10.3432C18.805 10.6166 18.9587 10.9876 18.9587 11.3743V18.666C18.9587 19.0528 18.805 19.4237 18.5315 19.6972C18.258 19.9707 17.8871 20.1243 17.5003 20.1243Z",
    fill: "#EE2B2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9648 23.272C15.9648 22.8647 16.1266 22.4741 16.4146 22.1861C16.7026 21.8981 17.0932 21.7363 17.5005 21.7363C17.9077 21.7363 18.2983 21.8981 18.5863 22.1861C18.8743 22.4741 19.0361 22.8647 19.0361 23.272C19.0361 23.6792 18.8743 24.0698 18.5863 24.3578C18.2983 24.6458 17.9077 24.8076 17.5005 24.8076C17.0932 24.8076 16.7026 24.6458 16.4146 24.3578C16.1266 24.0698 15.9648 23.6792 15.9648 23.272Z",
    fill: "#EE2B2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7603 6.76865L31.3294 22.402C33.5344 26.4255 30.6396 31.3532 26.0692 31.3532H8.93088C4.36047 31.3532 1.46422 26.4241 3.67067 22.4005L12.2398 6.76719C14.5236 2.60365 20.4765 2.60365 22.7603 6.76719V6.76865ZM20.1294 8.22698C18.989 6.14302 16.0111 6.14302 14.8707 8.22698L6.30005 23.8574C5.19609 25.8699 6.64422 28.333 8.92942 28.333H26.0678C28.353 28.333 29.8011 25.8684 28.6971 23.8559L20.1294 8.22698Z",
    fill: "#EE2B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryDeleteWarning);
export default __webpack_public_path__ + "static/media/historyDeleteWarning.88ea25ae2d6296fe26d1a20d585f6fe5.svg";
export { ForwardRef as ReactComponent };